import { ALL_MISTAKE_TYPES } from "@app/routes/activities/reading/constants";

export const getMistakesByType = (wordsStates, type, firstReadingWord, lastReadingWord) => Object.values(wordsStates).filter(
  (i) => (!firstReadingWord || (firstReadingWord && i.wordId >= firstReadingWord))
    && (!lastReadingWord || (lastReadingWord && i.wordId <= lastReadingWord))
    && i.problemType === type,
).length;

export const getTotalMistakes = (wordsStates, firstReadingWord, lastReadingWord) => (wordsStates && Object.values(wordsStates).filter(
  (i) => i.wordId >= firstReadingWord
    && (!lastReadingWord || (lastReadingWord && i.wordId <= lastReadingWord))
    && ALL_MISTAKE_TYPES.includes(i.problemType),
).length) || 0;

export const getMistakesCounts = (wordsStates, firstReadingWord, lastReadingWord) => {
  const res = { };

  Object.values(wordsStates).forEach(state => {
    const { problemType, wordId } = state;
    const isBetweenStartAndEnd = wordId >= firstReadingWord && (!lastReadingWord || (lastReadingWord && wordId <= lastReadingWord));
    if (isBetweenStartAndEnd) {
      res[problemType] = (res[problemType] || 0) + 1;
    }
  });
  return res;
};

